import styles from './CurrentPlanCard.module.css';

interface CurrentPlanCardProps {
	planName: string;
	priceLabel: string;
	isActive: boolean;
	cycleLabel: string;
	renewsLabel: string;
	sinceLabel: string;
	onUpgrade?: () => void;
}

export const CurrentPlanCard = ({
	planName,
	priceLabel,
	isActive,
	cycleLabel,
	renewsLabel,
	sinceLabel,
	onUpgrade,
}: CurrentPlanCardProps) => {
	return (
		<section className={styles.card}>
			<div className={styles.top}>
				<div className={styles.heading}>
					<span className={styles.kicker}>Seu plano atual</span>
					<div className={styles.nameRow}>
						<h2 className={styles.planName}>{planName}</h2>
						<span className={styles.badge}>
							<span
								className={`${styles.dot} ${isActive ? styles.dotActive : styles.dotInactive}`}
							/>
							{isActive ? 'Ativo' : 'Inativo'}
						</span>
					</div>
					<p className={styles.price}>{priceLabel}</p>
				</div>
				{onUpgrade ? (
					<button type="button" className={styles.upgrade} onClick={onUpgrade}>
						Fazer Upgrade
					</button>
				) : null}
			</div>
			<div className={styles.meta}>
				<div className={styles.metaItem}>
					<span className={styles.metaLabel}>Ciclo atual</span>
					<span className={styles.metaValue}>{cycleLabel}</span>
				</div>
				<div className={styles.metaItem}>
					<span className={styles.metaLabel}>Renova em</span>
					<span className={styles.metaValue}>{renewsLabel}</span>
				</div>
				<div className={styles.metaItem}>
					<span className={styles.metaLabel}>Assinante desde</span>
					<span className={styles.metaValue}>{sinceLabel}</span>
				</div>
			</div>
		</section>
	);
};
